import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  prepareDefaultLookupFieldsConfig,
  prepareDefaultLookupFieldsValue
} from '../../adapters/default-lookup-eval/default-lookup-eval.adapter';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getDefaultLookupState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.defaultLookup
);

export const shouldTriggerDefaultLookupApi = createSelector(
  getDefaultLookupState,
  ({ isReadyOnLanding, triggerDefaultsLookupLanding }) =>
    triggerDefaultsLookupLanding && !isReadyOnLanding
);

export const isDefaultLookupStateReady = createSelector(
  getDefaultLookupState,
  ({ isReadyOnLanding, triggerDefaultsLookupLanding, isError }) =>
    !triggerDefaultsLookupLanding || isReadyOnLanding || isError
);

export const getCacheKeySuffix = createSelector(
  getDefaultLookupState,
  ({ cacheKeySuffix, defaultLookupLandingData }) =>
    cacheKeySuffix ||
    defaultLookupLandingData?.searchCriteria?.request?.cacheKey ||
    ''
);

export const getDefaultsLookupFieldsValue = createSelector(
  getDefaultLookupState,
  ({ defaultLookupLandingData }) =>
    prepareDefaultLookupFieldsValue(defaultLookupLandingData)
);

export const getDefaultsLookupFieldsConfig = createSelector(
  getDefaultLookupState,
  ({ defaultLookupLandingData }) =>
    prepareDefaultLookupFieldsConfig(defaultLookupLandingData)
);
